import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./i18n/LangContext";
import { SettingsProvider } from "./context/SettingsContext";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { MobileBar } from "./components/site/MobileBar";
import { StructuredData } from "./components/site/Seo";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import RequestPage from "./pages/RequestPage";
import LegalPage from "./pages/LegalPage";
import NotFound from "./pages/NotFound";
import { AuthProvider, Protected } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import RequestDetail from "./admin/RequestDetail";
import SettingsPage from "./admin/SettingsPage";
import Notifications from "./admin/Notifications";
import Team from "./admin/Team";

const PublicLayout = () => (
  <>
    <StructuredData />
    <Header />
    <main id="main"><Outlet /></main>
    <Footer />
    <MobileBar />
  </>
);

const AdminShell = () => (
  <AuthProvider><Outlet /></AuthProvider>
);

function App() {
  return (
    <div className="App">
      <LangProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="request" element={<RequestPage />} />
                <Route path="services/:id" element={<ServicePage />} />
                <Route path="privacy" element={<LegalPage kind="privacy" />} />
                <Route path="terms" element={<LegalPage kind="terms" />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="admin" element={<AdminShell />}>
                <Route path="login" element={<AdminLogin />} />
                <Route element={<Protected><AdminLayout /></Protected>}>
                  <Route index element={<Dashboard />} />
                  <Route path="requests/:id" element={<RequestDetail />} />
                  <Route path="settings" element={<SettingsPage />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route path="team" element={<Team />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" />
        </SettingsProvider>
      </LangProvider>
    </div>
  );
}

export default App;
